import { BIModel } from './BIModel';

export class NotificationViewBIModel extends BIModel {

    static eventName = 'notification_view';
    #notificationId;
    #notificationType;
    #readFrom;

    constructor(
        userId,
        notificationId,
        notificationType,
        readFrom
    ) {
        super(NotificationViewBIModel.eventName, userId);
        this.#notificationId = notificationId;
        this.#notificationType = notificationType;
        this.#readFrom = readFrom;
       
    }

    get modelData() {
        return {
            notification_id: this.#notificationId,
            notification_type: this.#notificationType,
            is_logged_in: true,
            read_from: this.#readFrom,
        };
    }

}
